(function favoritesModuleDefinition() {
    'use strict';

    angular.module('Favorites', ['ui.router', 'Config', 'Entities', 'ErrorsExtend'])
        .config(['configProvider', '$stateProvider', 'loginProvider',
            function favoritesConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('favorites', {
                    url: "/Favorites/Detail",
                    templateUrl: config.resourceUrl('/views/favorites/favorites.html'),
                    controller: 'FavoritesController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT READ').or('DOCUMENTCONTAINER READ')
                });
            }
        ]);
})();